import { Injectable } from '@angular/core';

import { DirittiFdu } from '@app-lib';
import { map } from 'rxjs/operators';
import { NavBoxService } from '../_services/nav-box.service';

@Injectable()
export class PreventDirectNavigationGuard  {
  constructor(private _nav: NavBoxService) {}
  canActivate() {
    if (this._nav.diritti$) {
      return this._nav.diritti$.pipe(
        map((res: DirittiFdu) => {
          if (res && res.Modifica == true) {
            return true;
          } else {
            return false;
          }
        })
      );
    } else {
      // undefined

      return true;
    }
  }
}
